// src/slides/Slide10.jsx - 实战演练标题页
import React from 'react';

const Slide10 = () => {
  return (
    <div className="slide-content">
      <h2>III. 实战演练：AI 赋能开发</h2>
      <h3>案例展示：AI 如何重塑开发流程</h3>
      
      <div className="Slide10-content">
        <p>接下来的幻灯片将通过两个实际案例展示 AI 在开发中的威力：</p>
        <ul>
          <li>案例 1：Cursor + PlatformIO - 嵌入式开发利器</li>
          <li>案例 2：Trae + browser-use - AI 控制浏览器</li>
        </ul>
      </div>
      
      <div className="slide-note">
        AI 工具如何与现有技术栈结合，提升效率与创新
      </div>
      
      <div className="footer">从理论到实践：AI 开发的真实力量</div>
    </div>
  );
};

export default Slide10;